module.exports = __webpack_public_path__ + "img/deposit_guide.2d79c3ca.gif";